
















import {Component, Vue} from "vue-property-decorator";
import AlzuhudHeader from '@/components/AlzuhudHeader.vue';
import AppSection from '@/components/AppSection.vue';
import Footer from '@/components/Footer.vue';
import {State} from 'vuex-class';

@Component({
  components: {Footer, AppSection, AlzuhudHeader}
})
export default class http404 extends Vue {
  @State adminUser: any;
}
